export default __webpack_public_path__ + "static/media/bg-2of4.84220b8f.svg";